import { createFileRoute } from '@tanstack/react-router';
import { useMemo, useState } from 'react';
import { Card } from '@/components/Card/card';
import ComingSoonCover from '@/components/ComingSoonCover';
import { DataTable, DataTablePagination } from '@/components/DataTable';
import { FillScreen, HStack, VStack } from '@/components/Layout';
import SearchInput from '@/components/SearchInput';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { MOCK_ONLY_FEATURE_FLAG } from '@/constants/featureFlags';
import { featureFlags } from '@/lib/env';
import placeholder from '../_placeholders/-assets/placeholder-people.png';
import { useMemberTable } from './-hooks/useTable';
import { useLicenseMembers } from './-query';
export const Route = createFileRoute('/_staff/licenses/_list/people/')({
  component: LicensePeople
});
function LicensePeople() {
  const isMockEnabled = featureFlags.check(MOCK_ONLY_FEATURE_FLAG);
  const {
    data,
    isPending
  } = useLicenseMembers({
    enabled: isMockEnabled
  });
  const [keyword, setKeyword] = useState('');
  const [license, setLicense] = useState('all');
  const [department, setDepartment] = useState('all');
  const items = useMemo(() => data ?? [], [data]);
  const licenseOptions = useMemo(() => [...new Set(items.flatMap(item => item.licenses))].sort(), [items]);
  const departmentOptions = useMemo(() => [...new Set(items.map(item => item.department))].sort(), [items]);
  const rows = useMemo(() => {
    const lower = keyword.trim().toLowerCase();
    return items.filter(item => {
      if (license !== 'all' && !item.licenses.includes(license)) return false;
      if (department !== 'all' && item.department !== department) return false;
      if (!lower) return true;
      return [item.name, item.department, ...item.licenses].some(field => field.toLowerCase().includes(lower));
    });
  }, [items, keyword, license, department]);
  const {
    table,
    displayState
  } = useMemberTable(rows, isPending);

  // MOCK_ONLY 無効時は従来どおり ComingSoon（非破壊）
  if (!isMockEnabled) {
    return <ComingSoonCover placeholderImage={placeholder} />;
  }
  return <FillScreen className="flex flex-col gap-4 py-5">
      <VStack className="min-h-0 flex-1 gap-4 px-12">
        <Card className="p-2 shadow-xs">
          <HStack className="items-center gap-2">
            <SearchInput value={keyword} onChange={e => setKeyword(e.target.value)} placeholder="メンバー・部署・ライセンスで検索" className="w-[280px]" />
            <Select value={license} onValueChange={setLicense}>
              <SelectTrigger className="w-[200px]">
                <SelectValue placeholder="ライセンスで絞り込み" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">すべてのライセンス</SelectItem>
                {licenseOptions.map(option => <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>)}
              </SelectContent>
            </Select>
            <Select value={department} onValueChange={setDepartment}>
              <SelectTrigger className="w-[160px]">
                <SelectValue placeholder="部署で絞り込み" />
              </SelectTrigger>
              <SelectContent>
                <SelectItem value="all">すべての部署</SelectItem>
                {departmentOptions.map(option => <SelectItem key={option} value={option}>
                    {option}
                  </SelectItem>)}
              </SelectContent>
            </Select>
          </HStack>
        </Card>

        <Card className="min-h-0 flex-1 overflow-auto shadow-xs">
          <DataTable table={table} displayState={displayState} isHoverable onRowClick={null} />
        </Card>

        <DataTablePagination table={table} totalCount={rows.length} pageOptions={[20, 50, 100]} />
      </VStack>
    </FillScreen>;
}